<template>
  <FormularioBase
    :tiposPermitidos="['ORCAMENTO']"
    sistema="FORCA_VENDAS"
    moduloKey="ADMIN_FORMULARIOS_PESQUISA"
    tabTitulo="Formulários de Pesquisa"
    context="PESQUISA"
  />
</template>

<script>
import FormularioBase from "../../components/formularios/FormularioBase.vue";
export default { components: { FormularioBase } };
</script>
